// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__G1XEH","errorLogs":"styles_errorLogs__D7KgM"};